import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "navbar d-flex mx-2 navbar" }
const _hoisted_2 = { class: "navbar-nav dropdown-nav" }
const _hoisted_3 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-2 overflow-hidden"
}
const _hoisted_5 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_6 = ["data-bs-target", "id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "offcanvas-body" }
const _hoisted_11 = { class: "offcanvas-header justify-content-end" }
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = { class: "navbar-nav justify-content-end flex-grow-1 pe-3" }
const _hoisted_14 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_15 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MenuLink = _resolveComponent("MenuLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", {
        ref: "menu",
        class: _normalizeClass({'hidden': _ctx.hide})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayItems.filter(i => i.display !== false), (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item,
            class: "mx-1"
          }, [
            _createVNode(_component_MenuLink, {
              "link-class": "nav-link d-inline-flex align-bottom py-0",
              item: item,
              editor: _ctx.editor
            }, {
              default: _withCtx(() => [
                (item.icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      icon: item.icon
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                (item.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["item", "editor"]),
            (item.children && item.children.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children.filter(i => i.display !== false), (child) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: child,
                      class: "hover-muted-gray w-100 text-nowrap me-2"
                    }, [
                      _createVNode(_component_MenuLink, {
                        "link-class": "nav-link d-inline-flex align-bottom",
                        item: child,
                        editor: _ctx.editor
                      }, {
                        default: _withCtx(() => [
                          (child.icon)
                            ? (_openBlock(), _createBlock(_component_Icon, {
                                key: 0,
                                icon: child.icon
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          (child.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(child.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["item", "editor"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.hiddenItems.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-sm",
                type: "button",
                "data-bs-toggle": "offcanvas",
                "data-bs-target": '#offcanvas' + _ctx.rndId,
                id: 'offcanvasBtn' + _ctx.rndId
              }, _hoisted_8, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "offcanvas offcanvas-end",
                tabindex: "-1",
                id: 'offcanvas' + _ctx.rndId
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      "data-bs-dismiss": "offcanvas",
                      "aria-label": "Close",
                      "data-bs-target": '#offcanvas' + _ctx.rndId
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenItems.filter(i => i.display !== false), (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                        _createVNode(_component_MenuLink, {
                          "link-class": "nav-link d-inline-flex align-bottom py-0 mb-1",
                          item: item,
                          editor: _ctx.editor,
                          onClick: _ctx.closeCanvas
                        }, {
                          default: _withCtx(() => [
                            (item.icon)
                              ? (_openBlock(), _createBlock(_component_Icon, {
                                  key: 0,
                                  icon: item.icon
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true),
                            (item.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.name), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["item", "editor", "onClick"]),
                        (item.children && item.children.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children.filter(i => i.display !== false), (child) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: child,
                                class: "hover-muted-gray w-100 text-nowrap me-2"
                              }, [
                                _createVNode(_component_MenuLink, {
                                  "link-class": "nav-link d-inline-flex align-bottom py-0 mb-1 ms-2",
                                  item: child,
                                  editor: _ctx.editor
                                }, {
                                  default: _withCtx(() => [
                                    (child.icon)
                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                          key: 0,
                                          icon: child.icon,
                                          onClick: _ctx.closeCanvas
                                        }, null, 8, ["icon", "onClick"]))
                                      : _createCommentVNode("", true),
                                    (child.name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(child.name), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["item", "editor"])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _hoisted_16
                      ], 64))
                    }), 128))
                  ])
                ])
              ], 8, _hoisted_9)
            ], 64))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}